import React, { useState, useEffect, useRef } from 'react';
import './Home.css';

const Home = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const awardImages = [
    {
      src: '/assets/awards-and-ceremony/01.jpg',
      alt: 'Award ceremony - Government recognition',
      title: 'Government Recognition',
      description: 'Excellence in Export Performance',
      icon: 'fa fa-trophy',
      badge: '3 Star Export House'
    },
    {
      src: '/assets/awards-and-ceremony/02.jpg',
      alt: 'Award ceremony - Industry achievement',
      title: 'Industry Achievement',
      description: 'Outstanding Export Performance',
      icon: 'fa fa-medal',
      badge: 'ISO 22000:2005 Certified'
    },
    {
      src: '/assets/awards-and-ceremony/03.jpg',
      alt: 'Award ceremony - Quality excellence',
      title: 'Quality Excellence',
      description: 'Certified Quality Standards',
      icon: 'fa fa-certificate',
      badge: 'HACCP Certified'
    },
    {
      src: '/assets/awards-and-ceremony/04.jpg',
      alt: 'Award ceremony - Leadership recognition',
      title: 'Leadership Recognition',
      description: 'Industry Leadership Award',
      icon: 'fa fa-star',
      badge: '120+ International Importers'
    }
  ];

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % awardImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [awardImages.length]);

  const handleMouseEnter = () => {
    // Pause auto-slide when hovering
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleMouseLeave = () => {
    // Resume auto-slide when leaving hover
    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % awardImages.length);
      }, 5000);
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + awardImages.length) % awardImages.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % awardImages.length);
  };

  const features = [
    {
      icon: 'fa-star',
      title: '3 Star ⭐⭐⭐ Export House',
      description: 'Recognized by Government of India for outstanding export performance',
      color: '#f39c12'
    },
    {
      icon: 'fa-certificate',
      title: 'ISO 22000:2005 Certified',
      description: 'Food safety management system certification for quality assurance',
      color: '#27ae60'
    },
    {
      icon: 'fa-shield',
      title: 'HACCP Certified',
      description: 'Hazard Analysis Critical Control Points certification for food safety',
      color: '#3498db'
    },
    {
      icon: 'fa-globe',
      title: '120+ International Importers',
      description: 'Serving customers across Asia including Indonesia, Philippines, Malaysia, Thailand, Singapore, Sri Lanka, Vietnam, Kuwait, and China',
      color: '#9b59b6'
    }
  ];

  const products = [
    {
      name: 'Peanut JAVA',
      description: 'Premium quality Spanish variety peanuts',
      image: '/assets/product/java.jpg',
      features: ['Premium Quality', 'Spanish Variety', 'Export Ready']
    },
    {
      name: 'Peanut BOLD',
      description: 'High-quality Runner variety peanuts',
      image: '/assets/product/bold.jpg',
      features: ['High Quality', 'Runner Variety', 'Bulk Available']
    },
    {
      name: 'Blanched Peanuts',
      description: 'Whole and split blanched peanuts',
      image: '/assets/product/blanched-whole.png',
      features: ['Whole & Split', 'Blanched', 'Ready to Eat']
    },
  ];

  const stats = [
    { number: '26+', label: 'Years Experience', icon: 'fa-calendar' },
    { number: '120+', label: 'International Importers', icon: 'fa-globe' },
    { number: '15', label: 'Countries Served', icon: 'fa-flag' },
    { number: '100%', label: 'Quality Assured', icon: 'fa-check-circle' }
  ];

  return (
    <div className={`home-page ${isVisible ? 'visible' : ''}`}>
          {/* Hero Section */}
          <section className="home-hero">
        <div className="hero-background"></div>
        <div className="hero-gradient"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-badge">
                <i className="fa fa-star"></i>
                <span>3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House</span>
              </div>
              <h1 className="hero-title">
                Leading Global
                <span className="gradient-text"> Peanut Exporters</span>
              </h1>
              <h2 className="hero-subtitle">
                Transform your
                <span className="highlight"> Peanut Sourcing</span> Today
              </h2>
              <p className="hero-description">
                A trusted peanut export company offering premium quality, reliable supply, 
                competitive pricing and exceptional service at scale for international markets.
              </p>
              <div className="hero-buttons">
                <a href="/products" className="btn btn-primary">
                  <i className="fa fa-shopping-cart"></i>
                  Our Products
                </a>
                <a href="/contact-us" className="btn btn-outline">
                  <i className="fa fa-phone"></i>
                  Contact Us
                </a>
              </div>
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">26+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">120+</div>
                  <div className="stat-label">International Importers</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">15</div>
                  <div className="stat-label">Countries Served</div>
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="hero-image-container">
                <div className="floating-card card-1">
                  <i className="fa fa-certificate"></i>
                  <span>ISO Certified</span>
                </div>
                <div className="floating-card card-2">
                  <i className="fa fa-shield"></i>
                  <span>HACCP</span>
                </div>
                <div className="floating-card card-3">
                  <i className="fa fa-globe"></i>
                  <span>Global Reach</span>
                </div>
                <img 
                  src="/assets/home-page-main.jpg" 
                  alt="S. V. Gadag Ginning Factory" 
                  className="hero-main-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Our Export Services & Awards Section */}
      <section className="features-awards-section">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Our Export Services</h2>
            <h3>Awards & Recognition</h3>
            <p>Our commitment to quality and excellence has been recognized by various government bodies and industry organizations. Simplify your peanut sourcing with our comprehensive export solutions and quality assurance.</p>
          </div>
          
          <div className="features-tabs">
            <div className="tab-buttons">
              {features.map((feature, index) => (
                <button
                  key={index}
                  className="tab-button"
                  style={{ '--feature-color': feature.color }}
                >
                  <i className={`fa ${feature.icon}`}></i>
                  <span>{feature.title}</span>
                </button>
              ))}
            </div>
          </div>


          <div className="awards-slider-container">
            <div 
              className="awards-slider"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="slider-wrapper">
                <div 
                  className="slider-track" 
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {awardImages.map((award, index) => (
                    <div key={index} className="slide">
                      <div className="slide-image">
                        <img src={award.src} alt={award.alt} />
                        <div className="slide-overlay">
                          <div className="slide-content">
                            <h3>{award.title}</h3>
                            <p>{award.description}</p>
                            <div className="award-badge">
                              <i className={award.icon}></i>
                              <span>{award.badge}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Navigation Arrows */}
              <button className="slider-nav prev" onClick={goToPrevious}>
                <i className="fa fa-chevron-left"></i>
              </button>
              <button className="slider-nav next" onClick={goToNext}>
                <i className="fa fa-chevron-right"></i>
              </button>
              
              {/* Dots Indicator */}
              <div className="slider-dots">
                {awardImages.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <div className="section-badge">
                <i className="fa fa-building"></i>
                <span>About Our Company</span>
              </div>
              <h2>About S. V. Gadag Ginning Factory</h2>
              <p className="lead">
                A renowned processor and exporter of Agro commodities, specializing in the 
                export of Groundnut Seeds, Groundnut In-Shell, and its variants for the past 26 years.
              </p>
              <p>
                An <strong>ISO 22000:2005</strong>, HACCP certified company, SVG is a GoI recognized 
                3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House and has made its strong foothold with <strong>120+ importers</strong> 
                spanning across Asian countries.
              </p>
              <div className="about-features">
                <div className="feature-item">
                  <i className="fa fa-certificate"></i>
                  <div>
                    <h4>ISO 22000:2005 Certified</h4>
                    <p>Food safety management system certification</p>
                  </div>
                </div>
                <div className="feature-item">
                  <i className="fa fa-shield"></i>
                  <div>
                    <h4>HACCP Certified</h4>
                    <p>Hazard Analysis Critical Control Points certification</p>
                  </div>
                </div>
                <div className="feature-item">
                  <i className="fa fa-star"></i>
                  <div>
                    <h4>3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House</h4>
                    <p>Recognized by Government of India</p>
                  </div>
                </div>
              </div>
              <a href="/about/about-us" className="btn btn-primary">
                <i className="fa fa-arrow-right"></i>
                Learn More
              </a>
            </div>
            <div className="about-visual">
              <div className="stats-grid">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-card">
                    <div className="stat-icon">
                      <i className={`fa ${stat.icon}`}></i>
                    </div>
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
              <div className="about-image">
                <img 
                  src="/assets/cashews-impo.jpg" 
                  alt="About S. V. Gadag Ginning Factory" 
                  className="img-responsive"
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <i className="fa fa-play-circle"></i>
                    <span>Watch Our Story</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Products Section */}
      <section className="products-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Products</h2>
            <h3>Premium Peanut Varieties</h3>
            <p>We offer a wide range of premium quality peanut products that meet 
            international standards and customer requirements.</p>
          </div>
          
          <div className="products-grid">
            {products.map((product, index) => (
              <div key={index} className="product-card">
                <div className="product-image">
                  <img src={product.image} alt={product.name} className="img-responsive" />
                  <div className="product-badge">
                    <i className="fa fa-star"></i>
                    <span>Premium</span>
                  </div>
                </div>
                <div className="product-content">
                  <h4>{product.name}</h4>
                  <p>{product.description}</p>
                  <div className="product-features">
                    {product.features.map((feature, idx) => (
                      <span key={idx} className="feature-tag">{feature}</span>
                    ))}
                  </div>
                  <a href="/products" className="btn btn-outline">
                    <i className="fa fa-arrow-right"></i>
                    Details
                  </a>
                  <a href="/contact-us" className="btn btn-primary">
                    <i className="fa fa-phone"></i>
                    Contact
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-background">
          <div className="cta-pattern"></div>
        </div>
        <div className="container">
          <div className="cta-content">
            <div className="cta-text">
              <h2>Ready to Partner with Us?</h2>
              <p className="lead">
                Contact us today to discuss your peanut export requirements and discover 
                how we can help you achieve your business goals.
              </p>
              <div className="cta-buttons">
                <a href="/contact-us" className="btn btn-primary">
                  <i className="fa fa-phone"></i>
                  Get Quote
                </a>
                <a href="/products" className="btn btn-outline">
                  <i className="fa fa-shopping-cart"></i>
                  View Products
                </a>
              </div>
            </div>
            <div className="cta-visual">
              <div className="cta-image">
                <img src="/assets/peanuts-show.png" alt="Contact Us" />
                <div className="floating-elements">
                  <div className="floating-element element-1">
                    <i className="fa fa-phone"></i>
                  </div>
                  <div className="floating-element element-2">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <div className="floating-element element-3">
                    <i className="fa fa-globe"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;